
import { ref } from "vue";
import store from "../store/index";
import { useRouter } from "vue-router";
import toNav from "@/components/ToNav.vue";
import { showDialog } from "vant";
// import CarouselThree from "@/components/CarouselThree.vue";
import { reactive } from "vue";
import { float } from "html2canvas/dist/types/css/property-descriptors/float";
export default {
  components: {
    toNav,
    // CarouselThree,
  },
  data() {
    return {
      radio: "1",
      radioVal: 0,
      checkVal: ref([]),
      aimQus: 0,
      questions: store.state.questions,
      activeIcon: "/static/img/xing.png",
      inactiveIcon: "/static/img/tuo.png",
      showflag: false,
    };
  },
  props: ["postaimqus"],
  setup(props, any) {
    let show = ref(false);
    let showflag = ref(false);

    const images = [
      "/static/img/bing1.png",
      "/static/img/bing2.png",
      "/static/img/bing3.png",
      "/static/img/bing4.png",
      "/static/img/bing5.png",
    ];

    const imgs = reactive([
      {
        id: 0,
        url: " /static/img/ad1.jpg",
      },
      {
        id: 1,
        url: " /static/img/ad2.jpg",
      },
      {
        id: 2,
        url: " /static/img/ad3.jpg",
      },
    ]);

    show = ref(true);
    //router是全局路由对象，route= userRoute()是当前路由对象
    let router = useRouter();
    const checked = ref("");
    let name = "张三";
    let age = "18";

    let checkedd = ref(true);
    return {
      checked,
      age,
      imgs,
      checkedd,
      images,
    };
  },
  methods: {
    // jump() {},

    tansuo() {
      this.show = true;
      // this.$router.push({ path: "/tansuo" });
      if (this.checkVal.length > 0) {
        this.$router.push({ path: "/tansuo" });
      } else {
        showDialog({
          title: "提示",
          message: "您还没有选择答案！",
        }).then(() => {
          this.showDialog = false;
        });
      }
    },
    showText() {
      console.log(this.show + "test it!");
      this.showflag = true;
      console.log(this.images + "test it!");
    },

    jieguo() {
      this.show = true;
      console.log(this.show + "test it!");
    },
    nexStept() {
      const aimQus = this.$route.query.aimQus;

      if (this.postaimqus == 0) {
        if (this.radioVal == 1) {
          this.aimQus = 1; //0开始 0-4
        } else {
          this.aimQus = 1; //0开始 0-4
          console.log(this.aimQus + "闯关失败，显示失败,传参继续探寻");
        }
      } else if (this.postaimqus == 1) {
        if (this.radioVal == 3) {
          console.log(this.aimQus + "继续闯关,显示成功,传参继续探寻");
        } else {
          // this.$router.push({
          //   path: "/correct",
          //   query: { postaimqus: "1", correct: "2" },
          // });
        }
      } else if (this.postaimqus == 2) {
        if (this.radioVal == 3) {
          // this.aimQus = 3; //0开始 0-4
          // console.log(this.aimQus + "继续闯关,显示成功,传参继续探寻");
        } else {
          // this.aimQus = 2; //0开始 0-4
          // console.log(this.aimQus + "闯关失败，显示失败,传参继续探寻");
        }
      } else if (this.postaimqus == 3) {
        if (this.radioVal == 1) {
          // this.aimQus = 4; //0开始 0-4
          // console.log(this.aimQus + "继续闯关,显示成功,传参继续探寻");
        } else {
          // this.aimQus = 4; //0开始 0-4
          // console.log(this.aimQus + "闯关失败，显示失败,传参继续探寻");
        }
      }

      // if (this.postaimqus == 4) {
      //   this.aimQus = 5;
      // }

      if (this.postaimqus == 5) {
        this.$router.push({
          path: "/report",
          // query: { postaimqus: "1", correct: "two" },
        });
      }

      this.$emit("onChanged", [this.postaimqus, this.radioVal]);
    },
  },
};
